// Danish
export default {
  newVersionAvailable: 'Ny version tilgængelig',
  versionInfo: 'En ny version af {appName} er tilgængelig. Genindlæs venligst siden for at opdatere til version {version}.',
  reload: 'Genindlæs',
  later: 'Senere',
}
